import { alertSuccess, alertError } from './alert';
import { putSupplier, getSupplier, getProductFilters } from './api/suppliers';
import { setRole } from './roles';
import { SUPPLIER } from '../../constants/roles';
import { setProductFilters } from './productFilters';

export const setSupplierIntegration = (publishable_key, secret_key) => async (dispatch, getState) => {
  try {
    const { supplierId } = getState().role;
    const data = {};

    if (typeof publishable_key === 'string') {
      data.stripe_publishable_key = publishable_key === '' ? null : publishable_key;
    }

    if (typeof secret_key === 'string') {
      data.stripe_secret_key = secret_key === '' ? null : secret_key;
    }

    const response = await putSupplier(supplierId, data);

    if (response.data.success) {
      const supplierResponse = await getSupplier(supplierId);
      dispatch(setRole(SUPPLIER, supplierResponse.data));
      dispatch(alertSuccess('Stripe keys successfully changed'));
    } else {
      dispatch(alertError('Error updating supplier integration'));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const getSupplierProductFilters = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const { supplierId } = state.role;
    const response = await getProductFilters(supplierId);

    dispatch(setProductFilters(response.data));
  } catch (error) {
    dispatch(alertError(error));
  }
};
